/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      owner
      name
      description
      address
      website
      profileImage {
        name
        key
        url
        __typename
      }
      locationId
      location {
        id
        owner
        name
        zip
        address1
        address2
        address3
        user {
          id
          owner
          name
          description
          address
          website
          profileImage {
            name
            key
            url
            __typename
          }
          locationId
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationUserId
        __typename
      }
      materials {
        items {
          id
          owner
          title
          description
          woodType
          kind
          price
          characters
          size {
            x
            y
            z
            __typename
          }
          thicknesses
          finishes
          dryingMethods
          originalImage {
            name
            key
            url
            __typename
          }
          scannedImage {
            name
            key
            url
            __typename
          }
          dxfFile {
            name
            key
            url
            __typename
          }
          images {
            name
            key
            url
            __typename
          }
          isOnSale
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          comments {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          userMaterialsId
          locationMaterialsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      owner
      name
      description
      address
      website
      profileImage {
        name
        key
        url
        __typename
      }
      locationId
      location {
        id
        owner
        name
        zip
        address1
        address2
        address3
        user {
          id
          owner
          name
          description
          address
          website
          profileImage {
            name
            key
            url
            __typename
          }
          locationId
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationUserId
        __typename
      }
      materials {
        items {
          id
          owner
          title
          description
          woodType
          kind
          price
          characters
          size {
            x
            y
            z
            __typename
          }
          thicknesses
          finishes
          dryingMethods
          originalImage {
            name
            key
            url
            __typename
          }
          scannedImage {
            name
            key
            url
            __typename
          }
          dxfFile {
            name
            key
            url
            __typename
          }
          images {
            name
            key
            url
            __typename
          }
          isOnSale
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          comments {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          userMaterialsId
          locationMaterialsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      owner
      name
      description
      address
      website
      profileImage {
        name
        key
        url
        __typename
      }
      locationId
      location {
        id
        owner
        name
        zip
        address1
        address2
        address3
        user {
          id
          owner
          name
          description
          address
          website
          profileImage {
            name
            key
            url
            __typename
          }
          locationId
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationUserId
        __typename
      }
      materials {
        items {
          id
          owner
          title
          description
          woodType
          kind
          price
          characters
          size {
            x
            y
            z
            __typename
          }
          thicknesses
          finishes
          dryingMethods
          originalImage {
            name
            key
            url
            __typename
          }
          scannedImage {
            name
            key
            url
            __typename
          }
          dxfFile {
            name
            key
            url
            __typename
          }
          images {
            name
            key
            url
            __typename
          }
          isOnSale
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          comments {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          userMaterialsId
          locationMaterialsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLocation = /* GraphQL */ `
  mutation CreateLocation(
    $input: CreateLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    createLocation(input: $input, condition: $condition) {
      id
      owner
      name
      zip
      address1
      address2
      address3
      user {
        id
        owner
        name
        description
        address
        website
        profileImage {
          name
          key
          url
          __typename
        }
        locationId
        location {
          id
          owner
          name
          zip
          address1
          address2
          address3
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          locationUserId
          __typename
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      materials {
        items {
          id
          owner
          title
          description
          woodType
          kind
          price
          characters
          size {
            x
            y
            z
            __typename
          }
          thicknesses
          finishes
          dryingMethods
          originalImage {
            name
            key
            url
            __typename
          }
          scannedImage {
            name
            key
            url
            __typename
          }
          dxfFile {
            name
            key
            url
            __typename
          }
          images {
            name
            key
            url
            __typename
          }
          isOnSale
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          comments {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          userMaterialsId
          locationMaterialsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationUserId
      __typename
    }
  }
`;
export const updateLocation = /* GraphQL */ `
  mutation UpdateLocation(
    $input: UpdateLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    updateLocation(input: $input, condition: $condition) {
      id
      owner
      name
      zip
      address1
      address2
      address3
      user {
        id
        owner
        name
        description
        address
        website
        profileImage {
          name
          key
          url
          __typename
        }
        locationId
        location {
          id
          owner
          name
          zip
          address1
          address2
          address3
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          locationUserId
          __typename
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      materials {
        items {
          id
          owner
          title
          description
          woodType
          kind
          price
          characters
          size {
            x
            y
            z
            __typename
          }
          thicknesses
          finishes
          dryingMethods
          originalImage {
            name
            key
            url
            __typename
          }
          scannedImage {
            name
            key
            url
            __typename
          }
          dxfFile {
            name
            key
            url
            __typename
          }
          images {
            name
            key
            url
            __typename
          }
          isOnSale
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          comments {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          userMaterialsId
          locationMaterialsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationUserId
      __typename
    }
  }
`;
export const deleteLocation = /* GraphQL */ `
  mutation DeleteLocation(
    $input: DeleteLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    deleteLocation(input: $input, condition: $condition) {
      id
      owner
      name
      zip
      address1
      address2
      address3
      user {
        id
        owner
        name
        description
        address
        website
        profileImage {
          name
          key
          url
          __typename
        }
        locationId
        location {
          id
          owner
          name
          zip
          address1
          address2
          address3
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          locationUserId
          __typename
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      materials {
        items {
          id
          owner
          title
          description
          woodType
          kind
          price
          characters
          size {
            x
            y
            z
            __typename
          }
          thicknesses
          finishes
          dryingMethods
          originalImage {
            name
            key
            url
            __typename
          }
          scannedImage {
            name
            key
            url
            __typename
          }
          dxfFile {
            name
            key
            url
            __typename
          }
          images {
            name
            key
            url
            __typename
          }
          isOnSale
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          comments {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          userMaterialsId
          locationMaterialsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationUserId
      __typename
    }
  }
`;
export const createMaterial = /* GraphQL */ `
  mutation CreateMaterial(
    $input: CreateMaterialInput!
    $condition: ModelMaterialConditionInput
  ) {
    createMaterial(input: $input, condition: $condition) {
      id
      owner
      title
      description
      woodType
      kind
      price
      characters
      size {
        x
        y
        z
        __typename
      }
      thicknesses
      finishes
      dryingMethods
      originalImage {
        name
        key
        url
        __typename
      }
      scannedImage {
        name
        key
        url
        __typename
      }
      dxfFile {
        name
        key
        url
        __typename
      }
      images {
        name
        key
        url
        __typename
      }
      isOnSale
      user {
        id
        owner
        name
        description
        address
        website
        profileImage {
          name
          key
          url
          __typename
        }
        locationId
        location {
          id
          owner
          name
          zip
          address1
          address2
          address3
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          locationUserId
          __typename
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      location {
        id
        owner
        name
        zip
        address1
        address2
        address3
        user {
          id
          owner
          name
          description
          address
          website
          profileImage {
            name
            key
            url
            __typename
          }
          locationId
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationUserId
        __typename
      }
      comments {
        items {
          id
          owner
          content
          material {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          createdAt
          updatedAt
          materialCommentsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      userMaterialsId
      locationMaterialsId
      __typename
    }
  }
`;
export const updateMaterial = /* GraphQL */ `
  mutation UpdateMaterial(
    $input: UpdateMaterialInput!
    $condition: ModelMaterialConditionInput
  ) {
    updateMaterial(input: $input, condition: $condition) {
      id
      owner
      title
      description
      woodType
      kind
      price
      characters
      size {
        x
        y
        z
        __typename
      }
      thicknesses
      finishes
      dryingMethods
      originalImage {
        name
        key
        url
        __typename
      }
      scannedImage {
        name
        key
        url
        __typename
      }
      dxfFile {
        name
        key
        url
        __typename
      }
      images {
        name
        key
        url
        __typename
      }
      isOnSale
      user {
        id
        owner
        name
        description
        address
        website
        profileImage {
          name
          key
          url
          __typename
        }
        locationId
        location {
          id
          owner
          name
          zip
          address1
          address2
          address3
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          locationUserId
          __typename
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      location {
        id
        owner
        name
        zip
        address1
        address2
        address3
        user {
          id
          owner
          name
          description
          address
          website
          profileImage {
            name
            key
            url
            __typename
          }
          locationId
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationUserId
        __typename
      }
      comments {
        items {
          id
          owner
          content
          material {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          createdAt
          updatedAt
          materialCommentsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      userMaterialsId
      locationMaterialsId
      __typename
    }
  }
`;
export const deleteMaterial = /* GraphQL */ `
  mutation DeleteMaterial(
    $input: DeleteMaterialInput!
    $condition: ModelMaterialConditionInput
  ) {
    deleteMaterial(input: $input, condition: $condition) {
      id
      owner
      title
      description
      woodType
      kind
      price
      characters
      size {
        x
        y
        z
        __typename
      }
      thicknesses
      finishes
      dryingMethods
      originalImage {
        name
        key
        url
        __typename
      }
      scannedImage {
        name
        key
        url
        __typename
      }
      dxfFile {
        name
        key
        url
        __typename
      }
      images {
        name
        key
        url
        __typename
      }
      isOnSale
      user {
        id
        owner
        name
        description
        address
        website
        profileImage {
          name
          key
          url
          __typename
        }
        locationId
        location {
          id
          owner
          name
          zip
          address1
          address2
          address3
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          locationUserId
          __typename
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      location {
        id
        owner
        name
        zip
        address1
        address2
        address3
        user {
          id
          owner
          name
          description
          address
          website
          profileImage {
            name
            key
            url
            __typename
          }
          locationId
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationUserId
        __typename
      }
      comments {
        items {
          id
          owner
          content
          material {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
            __typename
          }
          createdAt
          updatedAt
          materialCommentsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      userMaterialsId
      locationMaterialsId
      __typename
    }
  }
`;
export const createComment = /* GraphQL */ `
  mutation CreateComment(
    $input: CreateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    createComment(input: $input, condition: $condition) {
      id
      owner
      content
      material {
        id
        owner
        title
        description
        woodType
        kind
        price
        characters
        size {
          x
          y
          z
          __typename
        }
        thicknesses
        finishes
        dryingMethods
        originalImage {
          name
          key
          url
          __typename
        }
        scannedImage {
          name
          key
          url
          __typename
        }
        dxfFile {
          name
          key
          url
          __typename
        }
        images {
          name
          key
          url
          __typename
        }
        isOnSale
        user {
          id
          owner
          name
          description
          address
          website
          profileImage {
            name
            key
            url
            __typename
          }
          locationId
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        location {
          id
          owner
          name
          zip
          address1
          address2
          address3
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          locationUserId
          __typename
        }
        comments {
          items {
            id
            owner
            content
            createdAt
            updatedAt
            materialCommentsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userMaterialsId
        locationMaterialsId
        __typename
      }
      createdAt
      updatedAt
      materialCommentsId
      __typename
    }
  }
`;
export const updateComment = /* GraphQL */ `
  mutation UpdateComment(
    $input: UpdateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    updateComment(input: $input, condition: $condition) {
      id
      owner
      content
      material {
        id
        owner
        title
        description
        woodType
        kind
        price
        characters
        size {
          x
          y
          z
          __typename
        }
        thicknesses
        finishes
        dryingMethods
        originalImage {
          name
          key
          url
          __typename
        }
        scannedImage {
          name
          key
          url
          __typename
        }
        dxfFile {
          name
          key
          url
          __typename
        }
        images {
          name
          key
          url
          __typename
        }
        isOnSale
        user {
          id
          owner
          name
          description
          address
          website
          profileImage {
            name
            key
            url
            __typename
          }
          locationId
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        location {
          id
          owner
          name
          zip
          address1
          address2
          address3
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          locationUserId
          __typename
        }
        comments {
          items {
            id
            owner
            content
            createdAt
            updatedAt
            materialCommentsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userMaterialsId
        locationMaterialsId
        __typename
      }
      createdAt
      updatedAt
      materialCommentsId
      __typename
    }
  }
`;
export const deleteComment = /* GraphQL */ `
  mutation DeleteComment(
    $input: DeleteCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    deleteComment(input: $input, condition: $condition) {
      id
      owner
      content
      material {
        id
        owner
        title
        description
        woodType
        kind
        price
        characters
        size {
          x
          y
          z
          __typename
        }
        thicknesses
        finishes
        dryingMethods
        originalImage {
          name
          key
          url
          __typename
        }
        scannedImage {
          name
          key
          url
          __typename
        }
        dxfFile {
          name
          key
          url
          __typename
        }
        images {
          name
          key
          url
          __typename
        }
        isOnSale
        user {
          id
          owner
          name
          description
          address
          website
          profileImage {
            name
            key
            url
            __typename
          }
          locationId
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        location {
          id
          owner
          name
          zip
          address1
          address2
          address3
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
            __typename
          }
          materials {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          locationUserId
          __typename
        }
        comments {
          items {
            id
            owner
            content
            createdAt
            updatedAt
            materialCommentsId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userMaterialsId
        locationMaterialsId
        __typename
      }
      createdAt
      updatedAt
      materialCommentsId
      __typename
    }
  }
`;
